import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../authentication.service';
import { ApiService, LocalStorageService, Cluster, CLUSTERS, CAMPUSES, ROLES, User, Campus } from '../../../../shared';
import { switchMap, delay } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';

class Credentials {
  email: string;
  password: string;
}

@Component({
  selector: 'app-sign-in-page',
  templateUrl: './sign-in-page.component.html',
  styleUrls: ['./sign-in-page.component.css']
})
export class SignInPageComponent implements OnInit {
  credentials: Credentials;

  constructor(
      private router: Router,
      private authService: AuthenticationService,
      private apiService: ApiService,
      private storageService: LocalStorageService
    ) {}

  ngOnInit() {
    this.credentials = new Credentials();
  }

  public login() {
    this.authService.login(this.credentials.email, this.credentials.password)
      .subscribe(() => this.defineClusterName());
  }
  
  
  /**
   * VA teacher on dark side
   * VA grad student will join dark side
   * VA undergrad is on light side
   * IL does't have sides
   */
  defineClusterName() {
    forkJoin(
      this.apiService.getMe(),
      this.apiService.getMyCampus()
    )
    .subscribe(([user, campus]) => this.pullAndSetClusterName(user, campus))
  }

  pullAndSetClusterName(user: User, campus: Campus) {
    if (user.role === ROLES.TEACHER) {
      switch (campus.location) {
        case CAMPUSES.VA: {
          this.setClusterNameAndReroute(CLUSTERS.VA.DARK);
          break;
        }
        case CAMPUSES.IL: {
          this.setClusterNameAndReroute(CLUSTERS.IL);
          break;
        }
      }
    } else {
      this.apiService.getMyBatch()
      .subscribe(batch => {
        switch (campus.location) {
          case CAMPUSES.VA: {
            if (batch.isGraduated) {
              this.setClusterNameAndReroute(CLUSTERS.VA.DARK);
              break;
            } else {
              this.setClusterNameAndReroute(CLUSTERS.VA.LIGHT);
              break;
            }
          }
          case CAMPUSES.IL: {
            this.setClusterNameAndReroute(CLUSTERS.IL);
            break;
          }
        }
      });
    }
  }

  setClusterNameAndReroute(clusterName: string){
    this.storageService.setClusterName(clusterName);
    this.router.navigateByUrl('/map');
  }
}




// WEBPACK FOOTER //
// ./src/app/core/authentication/pages/sign-in-page/sign-in-page.component.ts